import { render, staticRenderFns } from "./ExtendExpiredDayModal.vue?vue&type=template&id=5b2ebd89&scoped=true&"
import script from "./ExtendExpiredDayModal.vue?vue&type=script&lang=js&"
export * from "./ExtendExpiredDayModal.vue?vue&type=script&lang=js&"
import style0 from "./ExtendExpiredDayModal.vue?vue&type=style&index=0&id=5b2ebd89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ebd89",
  null
  
)

export default component.exports